import classnames from 'classnames'
import { Link } from 'react-router-dom'

import { Avatar, IMAGE_SIZES } from 'images'
import { ProgressBar, SimpleButton } from 'ui'

import type { FC } from 'react'

import type { InstitutionSchema } from 'search'

type InstitutionProps = {
  className?: string
  institution: InstitutionSchema.Institution
  onToggleFollow?: (institution: InstitutionSchema.Institution) => void
}

const Institution: FC<InstitutionProps> = ({ className, institution, onToggleFollow }) => {
  const progress = 0
  const isFollowing = Number(institution.following?.length || 0) > 0

  return (
    <div
      className={classnames(
        'border hover:border-green focus-within:border-green hover:shadow focus-within:shadow rounded',
        className,
      )}
    >
      <div className="flex gap-1 items-center px-1 pt-1">
        <Link className="shrink-0 font-bold truncate !no-underline" tabIndex={-1} to={`/institution/${institution.id}`}>
          <Avatar
            fallbackIconName="trophy"
            size="4em"
            src={institution.avatar}
            srcImageSize={IMAGE_SIZES.FIT_100_100}
          />
        </Link>
        <div className="grow flex flex-col overflow-hidden">
          <Link className="font-bold truncate" to={`/institution/${institution.id}`}>
            {institution.name}
          </Link>
          <div className="text-sm truncate text-greyDark">
            <i className={`flag ${institution.country_code} !m-0`} /> {institution.city.name}, {institution.type.name}
          </div>
          <b className="text-xs truncate text-greyDark">{institution.tournaments_count} torneos</b>
        </div>
      </div>
      <div className="flex justify-end items-center gap-2 text-sm">
        {!!onToggleFollow && (
          <SimpleButton
            icon={isFollowing ? 'check' : 'feed'}
            onClick={() => onToggleFollow(institution)}
            primary={isFollowing}
            value={isFollowing ? 'Siguiendo' : 'Seguir'}
          />
        )}
      </div>
      <ProgressBar ariaLabel="Avance del torneo" className="text-xxs" tabIndex={-1} value={progress} />
    </div>
  )
}

export default Institution
